// src/components/tutor/TutorSchedulePage.js
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import TutorScheduling from "./schedule/TutorScheduling";

export default function TutorSchedulePage() {
  const [currentUserUid, setCurrentUserUid] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUserUid(user.uid);
      } else {
        setCurrentUserUid(null);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  if (!currentUserUid) {
    return <div style={{ padding: 20 }}>Please log in to view your schedule.</div>;
  }

  return (
    <div style={{ 
      width: "100%", 
      minHeight: "100vh",
      display: "flex", 
      flexDirection: "column", 
      backgroundColor: "#f3f4f6" 
    }}>
      <TutorScheduling currentUserUid={currentUserUid} />
    </div>
  );
}